export default __webpack_public_path__ + "static/media/1155.012a5b7b.png";